import Adjectives from "../../components/ClassThree/English/Adjectives";
import Adverbs from "../../components/ClassThree/English/Adverbs";
import Comprehension from "../../components/ClassThree/English/Comprehension";
import Conjunctions from "../../components/ClassThree/English/Conjunctions";
import Interjections from "../../components/ClassThree/English/Interjections";
import Nouns from "../../components/ClassThree/English/Nouns";
import Prepositions from "../../components/ClassThree/English/Prepositions";
import Pronouns from "../../components/ClassThree/English/Pronouns";
import Punctuation from "../../components/ClassThree/English/Punctuation";
import Sentences from "../../components/ClassThree/English/Sentences";
import Tenses from "../../components/ClassThree/English/Tenses";
import Verbs from "../../components/ClassThree/English/Verbs";
import Vocabulary from "../../components/ClassThree/English/Vocabulary";

// Define the type for menu items
interface MenuItem {
    url: string;
    title: string;
    component?: React.FC; // Optional React functional component
    subMenu?: MenuItem[]; // Allow subMenu to be an array of MenuItem
}

const topics: MenuItem[] = [
    { url: "/class-three/english/nouns", title: "Nouns", component: Nouns },
    { url: "/class-three/english/pronouns", title: "Pronouns", component: Pronouns },
    { url: "/class-three/english/verbs", title: "Verbs", component: Verbs },
    { url: "/class-three/english/adjectives", title: "Adjectives", component: Adjectives },
    { url: "/class-three/english/adverbs", title: "Adverbs", component: Adverbs },
    { url: "/class-three/english/prepositions", title: "Prepositions", component: Prepositions },
    { url: "/class-three/english/conjunctions", title: "Conjunctions", component: Conjunctions },
    { url: "/class-three/english/interjections", title: "Interjections", component: Interjections },
    { url: "/class-three/english/sentence-structure", title: "Sentence Structure", component: Sentences },
    { url: "/class-three/english/tenses", title: "Tenses", component: Tenses },
    { url: "/class-three/english/vocabulary-word-skills", title: "Vocabulary & Word Skills", component: Vocabulary },
    { url: "/class-three/english/punctuation-capitalization", title: "Punctuation & Capitalization", component: Punctuation },
    { url: "/class-three/english/reading-comprehension", title: "Reading & Comprehension", component: Comprehension },
];


export default topics;